import Helpers from '@helpers';

const initCode = () => {

    //document.addEventListener("DOMContentLoaded", function () {
    //    var selectType = Helpers.Utils.getParameterByName('selected', null);
    //    if (selectType != null) {
    //        $('#drpSubject').val(parseInt(selectType)); 
    //    }
    //    if ($('#drpSubject').val() == 1 || $('#drpSubject').val() == 2 || $('#drpSubject').val() == 5) {
    //        $('#getCode').show();
    //        window["ValidatorEnable"](document.getElementById('SharedContent_ContentPlaceHolder2_ctl01'), true);
    //        $('#SharedContent_ContentPlaceHolder2_ctl01').css('display', 'none');
    //    } else {
    //        $('#getCode').hide();
    //        window["ValidatorEnable"](document.getElementById('SharedContent_ContentPlaceHolder2_ctl01'), false);
    //    }
    //});

    $('#drpSubject').change(function () {
        if ($('#drpSubject').val() == 1 || $('#drpSubject').val() == 2 || $('#drpSubject').val() == 5) {
            //$('#getCode').show();
            $($("#getCode").find('span')[0]).show();
            window["ValidatorEnable"](document.getElementById('SharedContent_ContentPlaceHolder2_ctl02'), true);
            $('#SharedContent_ContentPlaceHolder2_ctl02').css('display', 'none');
        } else {
            //$('#getCode').hide();
            $($("#getCode").find('span')[0]).hide();
            window["ValidatorEnable"](document.getElementById('SharedContent_ContentPlaceHolder2_ctl02'), false);
        }
    });
};

export {
    initCode
};
